import { Component, OnChanges, ChangeDetectionStrategy, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { SelectItem } from '../common';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsComponent implements OnChanges {

  @Input() tabs: SelectItem[];
  @Input() localStorageName: string;
  @Output() selectTab: EventEmitter<any> = new EventEmitter();

  @HostBinding('class.dt-tab') cssClass = true;
  private selected: any;

  constructor() { }

  ngOnChanges() {
    console.log(this.localStorageName)
    if (this.localStorageName) {
      console.log(localStorage.getItem(this.localStorageName))
      this.selected = localStorage.getItem(this.localStorageName);
      if (this.selected) {
        this.selectTab.emit(this.selected);
      }
    }
    if (!this.selected && this.tabs && this.tabs.length) {
      this.selected = this.tabs[0].id;
      this.selectTab.emit(this.selected);
    }
  }

  onClickTab(event: SelectItem) {
    this.selected = event.id;
    this.selectTab.emit(this.selected);
    console.log(this.localStorageName)
    if (this.localStorageName) {
      localStorage.setItem(this.localStorageName, this.selected);
      console.log(localStorage.getItem(this.localStorageName))
    }
  }

  isActive(tab: SelectItem): boolean {
    return this.selected === tab.id;
  }
}
